import styled from 'styled-components';

export const TagFieldSC = styled.div<{
  backgroundColor: string;
  textColor: string;
}>`
  .tag {
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ textColor }) => textColor};
    display: inline-block;
    font-weight: bold;
    font-size: 12px;
    line-height: 24px;

    border-radius: 12px;
    padding-left: 15px;
    padding-right: 15px;
  }
`;
